import loadable from '@loadable/component';
import React, { Fragment } from 'react';
import { SITE_MESSAGES } from '@localisation/message';

function Loading() {
  return <div> {SITE_MESSAGES.LOADING} </div>;
}

const fallBack = { fallback: Loading }

const LoadableOrgSelect = loadable(
  () => import(/* webpackChunkName: "orgSelect.page" */'./orgSelect.page'),
  fallBack,
);

const LoadableHome = loadable(
  () => import(/* webpackChunkName: "home.page" */'./home.page'),
  fallBack,
);

const LoadableForgetPassword = loadable(
  () => import(/* webpackChunkName: "forgetPassword.page" */'./forgetPassword.page'),
  fallBack,
);

const LoadableResetPassword = loadable(
  () => import(/* webpackChunkName: "resetPassword.page" */'./resetPassword.page'),
  fallBack,
);

const LoadableRoleList = loadable(
  () => import(/* webpackChunkName: "roles.page" */'./role/roleList.page'),
  fallBack,

);

const LoadableRoleDetail = loadable(
  () => import(/* webpackChunkName: "roles.page" */'./role/roleDetail.page'),
  fallBack,

);

const LoadableSubscriptionPlanList = loadable(
  () => import(/* webpackChunkName: "subscriptionPlan.page" */'./subscription/subscriptionPlanList.page'),
  fallBack,
);

const LoadableSubscriptionPlanDetail = loadable(
  () => import(/* webpackChunkName: "subscriptionPlan.page" */'./subscription/subscriptionPlanDetail.page'),
  fallBack,
);

const LoadableSubscriptionManagement = loadable(
  () => import(/* webpackChunkName: "subscription.page" */'./subscription/subscription.page'),
  fallBack,
);

const LoadableUserList = loadable(
  () => import(/* webpackChunkName: "users.page" */'./user/userList.page'),
  fallBack,
);

const LoadableUserDetail = loadable(
  () => import(/* webpackChunkName: "users.page" */'./user/userDetail.page'),
  fallBack,
);

const LoadableCampaignList = loadable(
  () => import(/* webpackChunkName: "campaign.page" */'./campaign/campaignList.page'),
  fallBack,
);

const LoadableCampaignDetail = loadable(
  () => import(/* webpackChunkName: "campaign.page" */'./campaign/campaignDetail.page'),
  fallBack,
);

const LoadableCampaignUserList = loadable(
  () => import(/* webpackChunkName: "campaignUser.page" */'./campaign/campaignUserList.page'),
  fallBack,
);

const LoadableCampaignUserDetail = loadable(
  () => import(/* webpackChunkName: "campaignUser.page" */'./campaign/campaignUserDetail.page'),
  fallBack,
);

const LoadableOrgList = loadable(
  () => import(/* webpackChunkName: "organisationManagement.page" */'./organisation/organisationList.page'),
  fallBack,
);

const LoadableOrgDetail = loadable(
  () => import(/* webpackChunkName: "organisationManagement.page" */'./organisation/organisationDetail.page'),
  fallBack,
);

const LoadableAccount = loadable(
  () => import(/* webpackChunkName: "account.page" */'./account/account.page'),
  fallBack,
);


const LoadableError = loadable(
  () => import(/* webpackChunkName: "error.page" */'./error.page'),
  fallBack,
);

const LoadableLanding = loadable(
  () => import(/* webpackChunkName: "landing.page" */'./landing.page'),
  fallBack,
);

const LoadablePublicUserPage = loadable(
  () => import(/* webpackChunkName: "publicUser.page" */'./publicUser.page'),
  fallBack,
);

const LoadableOidcCallback = loadable(
  () => import(/* webpackChunkName: "callback.page" */'./oidc/callback.page'),
  fallBack,
);

const LoadableOidcSilent = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./oidc/silent.page'),
  fallBack,
);

const LoadableTaas = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./taas/main.page'),
  fallBack,
);

const LoadableAide = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./aide/aide.homepage'),
  fallBack,
);

const LoadableAideScoutManager = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./aide/aide.scoutManager.page'),
  fallBack,
);

const LoadableAideScoutDetail = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./aide/aide.scoutDetail.page'),
  fallBack,
);

const LoadableScouts = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./taas/scouts.page'),
  fallBack,
);

const LoadableSeerDemo = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./seerdemo/main.page'),
);

const LoadableNerdTraining = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./nerdTraining/nerdTraining.page'),
  fallBack,
);

const LoadableNerdTrainingEntrance = loadable(
  () => import(/* webpackChunkName: "silent.page" */'./nerdTraining/nerdTrainingEntrance.page'),
  fallBack,
);

const LoadableCompanyDetail = loadable(
  () => import(/* webpackChunkName: "companyDetail.page" */'./companies/companyDetail.page'),
  fallBack
);

const KeyDevManager = loadable(
  () => import(/* webpackChunkName: "keyDevManager.page" */'./keydev/keyDevManager.page'),
  fallBack,
);

const KeyDevRequestLog = loadable(
  () => import(/* webpackChunkName: "keyDevRequestLog.page" */'./keydev/keyDevRequestLog.page'),
  fallBack,
);
const KeyDevQualityMonitoring = loadable(
  () => import(/* webpackChunkName: "keyDevQualityMonitoring.page" */'./keydev/keyDevQualityMonitoring.page'),
  fallBack,
);

const LoadableKeyDevDetail = loadable(
  () => import(/* webpackChunkName: "keydevDetail.page" */'./keydev/keydevDetail.page'),
  fallBack,
);

const LoadableKeyDevDetailUpdateHistory = loadable(
  () => import(/* webpackChunkName: "keydevDetailUpdateHistory.page" */'./keydev/keydevDetailUpdateHistory.page'),
  fallBack,
);

const KeyDevClusterManagement = loadable(
  () => import(/* webpackChunkName: "keyDevClusterManagement.page" */'./keydev/keyDevClusterManagement.page'),
  fallBack,
);

const LoadableLoginPage = loadable(
  () => import(/* webpackChunkName: "login.page" */'./login/login.page'),
  fallBack,
);

const loadableToFC = <P extends object>(Component: React.ComponentType<P>): React.ComponentType => {
  return (props: any) => {
    return (
      <Fragment>
        <Component {...props} />
      </Fragment>
    );
  };
};

export const Home = loadableToFC(LoadableHome);
export const ForgetPassword = loadableToFC(LoadableForgetPassword);
export const ResetPassword = loadableToFC(LoadableResetPassword);
export const Account = loadableToFC(LoadableAccount);
export const RoleList = loadableToFC(LoadableRoleList);
export const RoleDetail = loadableToFC(LoadableRoleDetail);
export const SubscriptionPlanList = loadableToFC(LoadableSubscriptionPlanList);
export const SubscriptionPlanDetail = loadableToFC(LoadableSubscriptionPlanDetail);
export const Subscription = loadableToFC(LoadableSubscriptionManagement);
export const UserList = loadableToFC(LoadableUserList);
export const UserDetail = loadableToFC(LoadableUserDetail);
export const CampaignList = loadableToFC(LoadableCampaignList);
export const CampaignDetail = loadableToFC(LoadableCampaignDetail);
export const CampaignUserList = loadableToFC(LoadableCampaignUserList);
export const CampaignUserDetail = loadableToFC(LoadableCampaignUserDetail);
export const OrganisationList = loadableToFC(LoadableOrgList);
export const OrganisationDetail = loadableToFC(LoadableOrgDetail);
export const OrgSelect = loadableToFC(LoadableOrgSelect);
export const ErrorPage = loadableToFC(LoadableError);

export const Landing = loadableToFC(LoadableLanding);
export const PublicUser = loadableToFC(LoadablePublicUserPage);
export const OidcCallback = loadableToFC(LoadableOidcCallback);
export const OidcSilent = loadableToFC(LoadableOidcSilent);

export const TaasPage = loadableToFC(LoadableTaas);
export const ScoutsPage = loadableToFC(LoadableScouts);
export const SeerDemoPage = loadableToFC(LoadableSeerDemo);

export const AidePage = loadableToFC(LoadableAide);
export const AideScoutManagerPage = loadableToFC(LoadableAideScoutManager);
export const AideScoutDetail = loadableToFC(LoadableAideScoutDetail);
export const NerdTrainingPage = loadableToFC(LoadableNerdTraining);
export const NerdTrainingEntrancePage = loadableToFC(LoadableNerdTrainingEntrance);
export const CompanyDetailPage = loadableToFC(LoadableCompanyDetail);
export const KeyDevManagerPage = loadableToFC(KeyDevManager);
export const keyDevRequestLogPage = loadableToFC(KeyDevRequestLog);
export const KeyDevQualityMonitoringPage = loadableToFC(KeyDevQualityMonitoring);
export const KeyDevDetail = loadableToFC(LoadableKeyDevDetail);
export const keydevDetailUpdateHistory = loadableToFC(LoadableKeyDevDetailUpdateHistory);
export const KeyDevClusterManagerPage = loadableToFC(KeyDevClusterManagement);
export const LoginPage = loadableToFC(LoadableLoginPage);
